import { useEventTracking } from '@/hooks/useEventTracking';
import { aegis } from "@/utils/monitoring";

/**
 * 通用日志工具，统一事件上报
 */

// 全局统一事件名
const GLOBAL_LOG_EVENT = 'app_log';

// 创建日志器的工厂函数
export const createLogger = (loggerName: string) => {
  const log = (level: 'debug' | 'info' | 'warn' | 'error', message: string, data?: any) => {
    // 控制台输出
    const consoleMethod = level === 'error' ? console.error : 
                         level === 'warn' ? console.warn : console.log;
    consoleMethod(`[${level.toUpperCase()}] ${message}`, data);
    
    // 统一埋点上报 - 所有日志都使用同一个事件名
    try {
      useEventTracking({
        event: GLOBAL_LOG_EVENT,
        eventValue: { logger: loggerName, message, hp_level: level, ...data }
      });
    } catch (error) {
      // 静默处理埋点错误
    }
    
    // Aegis 上报
    try {
      if (aegis) {
        const aegisData = {
          msg: `[${level.toUpperCase()}] ${message}`,
          level: level === 'debug' ? 1 : level === 'info' ? 2 : level === 'warn' ? 3 : 4,
          ext1: data?.clientId || '',
          ext2: JSON.stringify(data || {})
        };
        
        if (level === 'debug' && typeof aegis.info === 'function') {
          aegis.info(aegisData);
        } else if ((level === 'info' || level === 'warn') && typeof aegis.infoAll === 'function') {
          aegis.infoAll(aegisData);
        } else if (level === 'error' && typeof aegis.error === 'function') {
          aegis.error(aegisData);
        }
      }
    } catch (error) {
      // 静默处理 Aegis 错误
    }
  };
  
  return {
    debug: (message: string, data?: any) => log('debug', message, data),
    info: (message: string, data?: any) => log('info', message, data),
    warn: (message: string, data?: any) => log('warn', message, data),
    error: (message: string, data?: any) => log('error', message, data)
  };
};

// 预定义日志器
export const logger = createLogger('app');

// 通用埋点方法
export const logTrack = (event: string, eventValue: any) => {
  try {
    useEventTracking({ event, eventValue });
  } catch (error) {
    console.warn('埋点失败:', error);
  }
};